export default {
  'zh-CN': {
    product: {
      ProductsServices: '产品与服务',
      // SupplyMail: '供应链-海外直邮服务',
      SupplyMail: '海外直邮服务',
      ShipmentCoverage: '派送范围',
      Countries: '美国全境、英国、德国、澳大利亚、加拿大、意大利、法国、西班牙及其他欧洲41国',
      DeliveryTime: '物流时效',
      Days: '从揽收到完成派送平均时效8-12个工作日',
      TrackingShipment: '物流轨迹',
      Door: '门到门全程追踪，物流轨迹自动回传eBAY主站，也可在eDIS平台和橙联官网：www.orangeconnex.com/tracking上自主查询',
      ChargingMethod: '计费方式',
      Charge: '以克计费（美国、澳大利亚、加拿大单件包裹50g起计）',
      PickUp: '揽件范围',
      Cities: '中国境内55个城市提供揽收服务（1件起揽, 无额外揽收费用）',
      Ascan: 'A-Scan时效：24小时内上传A-Scan时间，A-Scan时间为实际揽收时间',
      PickupServer:'全国揽收服务',
      PickupServers:'SpeedPAK及Multi-Channel服务提供包含中国境内185个城市上门揽收、目的地预分拣、出口报关、国际运输、进口清关、终端配送及物流轨迹追踪等端到端的整体服务。旨在以提供优质稳定的物流服务，帮助卖家降低物流管理成本，提高物流派送时效，提升买家平台购买体验。',
      McPickupServers:'本服务通过匹配平台物流政策，提供包含中国境内185个城市上门揽收、目的地预分拣、出口报关、国际运输、进口清关、终端配送及物流轨迹追踪等端到端的整体服务。旨在以提供优质稳定的物流服务，帮助卖家降低物流管理成本，提高物流派送时效，提升买家平台购买体验。',
      PickupCoverag:'网点城市',
      PickupCoverags:'银川 济南 青岛 烟台 威海 潍坊 西安 咸阳 兰州 南昌 石家庄 白沟 廊坊 南京 无锡 苏州 南通 镇江 常州 连云港 郑州  南阳 杭州 金华 义乌 丽水 宁波 温州 乐清 台州 慈溪 瑞安 平阳 余姚 嘉兴 合肥 武汉 福州 厦门 泉州 晋江 成都 天津 葫芦岛 重庆 北京 长沙 上海  广州 汕头 东莞 佛山 中山 深圳 珠海 ',
      items: {
        '01': '覆盖全球52个国家和地区<br/>美国、英国、德国、澳大利亚、加拿大、法国、意大利、西班牙、以色列、新西兰及其他欧洲41国',
        '02': '从揽收到完成派送<br/>标准型服务：平均时效8-12个工作日<br/>经济型服务：平均时效10-15个工作日',
        '03': '物流轨迹可视追踪<br/>物流轨迹自动回传eBay主站，也可在eDIS平台和橙联官网www.orangeconnex.com/tracking上自主查询',
        '04': '<br/>以克计费(美国，澳大利亚及加拿大50g起计)',
        '05': '中国大陆地区26个省份，185个城市提供揽收服务(1件起揽，无额外揽收费用)<br/>香港地区提供多达14个站点的自送服务',
        '06': '24小时内上传A-Scan时间<br/>A-Scan时间为实际揽收时间',
        '07': '<br/>提供API对接方式，可对接第三方ERP'
      },
      pickup: '<h5><b></b></h5><br/>已开通揽收\+自送服务省份<br/>共27个省份(含香港)，185个地级市，788个区县<br/><br/>准备开通自送服务省份<br/>（共1个省份"台湾"，21个县市）<br/><br/>服务方式：上门揽收\+自送<br/>自送窗口时间: 周一至周六，10:00 – 18:00',
      warehouse:{
        warehouseIntr: 'Speed Freight海外仓头程服务',
        warehouseIntr1: '海运拼箱产品',
        warehouseIntr2: '通过卓越的系统建设能力及强大的供应商管理能力，橙联推出Speed Freight海外仓头程服务，助力广大卖家建立海外仓库存，将货物轻松销往全球。',
        itemsCf: {
          '01': '<b>海运拼箱+卡车派送</b><br/>每周固定船期，从上海、深圳始发至美国西岸和美国东岸',
          '02': '<br><b>覆盖美国全境的海外仓，服务范围不断扩展中</b>',
          '03': '<br><b>从货物进仓到完成海外仓收货平均美西22-33自然日，美东38-50自然日</b>',
          '04': '<br><b>国内集货仓每周7天均可收货（节假日除外）</b>',
          '05': '<b>便捷下单</b><br/>运营中心每周6天在线为客户答疑，可快速响应服务需求及日常查询',
          '06': '<b>物流轨迹可视追踪</b><br/>从货物进国内仓到送达目的海外仓，全程物流轨迹实时更新，可供客户随时查询',
          '07': '<b>开通上门揽收服务</b><br/>目前在上海、深圳、广州提供上门揽收，揽收城市持续扩展中',
          '08': '<b>订单计费透明</b><br/>实时浏览订单费用明细，账单一目了然',
          '09': '<b>货物安全有保障</b><br/>全程可监控，可提供商业保险服务，如遇丢失损坏等可在约定范围内赔付',
        },
      },
      finance:{
        '01': '<b>产品要点</b><br/>最高上限<b>30万元</b>，日息低至<b>0.03%</b>，最长期限<b>3个月</b>的纯信用贷款产品\n',
        '02': '<b>产品优势</b><br/>无需抵押，T+3工作日放款，全线上操作，自主支付，随借随还\n',
        '03': '<b>申请条件</b><br/>企业法人（或个体工商户经营者），20-55周岁，eBay店铺注册1年以</br>上，橙联物流使用半年以上，eBay平台月销售需达到人民币3万元以上\n',
        '04': '<b>使用流程</b><br/>SpeedPAK充值页面点击产品申请，提交用户授权后，登录金融机构页面申请</br>融资\n',
        '05': '<b>立即申请</b><br/>如对产品有需求，可联系橙联或登录SpeedPAK充值界面查看是否已开通产品入口 </br>(金融产品客服热线 400 165 0008）\n',

        intr1:'橙联推荐信用融资产品\n',
        intr2:'纯信用电商助业融资贷款\n'
      },
      multiChannel:{
        title:'Multi-Channel服务',
        intr:'Multi-Channel物流解决方案，是依托由eBay与Orange Connex联合打造的SpeedPAK物流服务网络为基础，致力于通过市场分析、系统研发及资源整合，为广大客户提供多渠道直发物流的服务产品。为全球跨境电商提供高品质、全方位的服务解决方案，助力客户跨境业务的增长及服务保证。',
        items:{
        '01': '覆盖全球52个国家和地区<br/>美国、英国、德国、澳大利亚、加拿大、法国、意大利、西班牙等',
        '02': '从揽收到完成派送<br/>标准型服务：平均时效8-12个工作日<br/>经济型服务：平均时效10-15个工作日',
        '03': '揽收覆盖范围：中国大陆地区185个地级市（1件起揽，无额外揽收费用）',
        '04': '物流轨迹自动回传<br/>可在ERP，17 Track, Multi-Channel卖家平台和OC官网多渠道查询',
        '05': '以克计费（美国、澳大利亚及加拿大50g起计，新加坡、马来西亚10g起计）',
        '06': '24小时以内上传A-Scan时间<br/>A-Scan时间为实际揽收时间',
        '07': '提供API对接方式，可对接第三方ERP',
        '08': '店小秘、马帮、通途、普源已入驻',
        }
      },
      tab2:'海外仓头程服务',
      spkInfo:'SpeedPAK直邮包裹服务是eBay联合物流战略合作伙伴橙联股份有限公司共同打造，以eBay平台物流政策为基础，为eBay大中华区跨境出口电商卖家量身定制的跨境直邮物流解决方案。',
      mcInfo:'Multi-Channel物流解决方案，是依托由eBay与Orange Connex联合打造的SpeedPAK物流服务网络为基础，为全球跨境电商提供高品质、全方位的服务解决方案。',
      shipmentCoverage1:'可达范围',
      shipmentCoverage2:'覆盖全球50个国家和地区',
      shipmentCoverage3:'美国、英国、德国、澳大利亚、加拿大、法国、意大利、西班牙、以色列、新西兰及其他欧洲41国',
      deliveryTime1:'从揽收到完成派送',
      deliveryTime2:'标准型服务：',
      deliveryTime3:'平均时效8-12个工作日',
      deliveryTime4:'经济型服务：',
      deliveryTime5:'平均时效10-15个工作日',
      chargeableUnits1:'以克计费',
      chargeableUnits2:'以克计费(美国，澳大利亚及加拿大50g起计)',
      tracking1:'物流轨迹可视追踪',
      tracking2:'运单查询',
      tracking3:'物流轨迹自动回传eBay主站，也可在eDIS平台和橙联官网自助查询',
      tracking4:'可在ERP，17 Track, Multi-Channel卖家平台和OC官网多渠道查询',
      pickupCoverage1:'揽收范围',
      pickupCoverage2:'中国大陆地区26个省份，185个城市提供揽收服务(1件起揽，无额外揽收费用)',
      pickupCoverage3:'香港地区提供多达14个站点的自送服务',
      aScan1:'A-Scan',
      aScan2:'24小时内上传A-Scan时间',
      aScan3:'A-Scan时间为实际揽收时间',
      mc1:'已入驻：',
      spk1:'提供API对接方式，可对接第三方ERP'
    }
  },
  'en-US':{
    product: {
      ProductsServices: 'Products and Services',
      // SupplyMail: 'Supply Chain-Direct Mail',
      SupplyMail: 'Direct Mail',
      ShipmentCoverage: 'Shipment Coverage',
      Countries: 'USA, United Kingdom, Germany, Australia, Canada, Italy, France, Spain, and 41 other European countries.',
      DeliveryTime: 'Delivery Time',
      Days: '8-12 business days for standard service.',
      TrackingShipment: 'Shipment Tracking',
      Door: 'End-to-end full service tracking with shipment information synchronized to ebay and eDIS platform in real time. Tracking service is also provided on the official website of Orange Connex: www.orangeconnex.com/tracking.',
      ChargingMethod: 'Chargeable Units',
      Charge: 'Shipment parcels are charged by weights (g). Chargeable thresholds for USA, Australia, and Canada starting at 50g/parcel; Chargeable thresholds for European countries starting at 1g/parcel.',
      PickUp: 'Pick-up Coverage',
      Cities: ' 55 cities in China (Starting with 1 package, no service fee); ',
      Ascan: 'A-Scan: 24 hours A-Scan upload guaranteed; A-Scan time recorded at pick-up.',
      PickupServer:'Nationwide Pick-Up Service',
      PickupServers:'Our service includes pick-up in 185 cities, sortation, export declaration, international shipping, import customs clearance, last-mile delivery, and shipment tracking. SpeedPAK is aimed to redefine our users’ cross border logistics experiences through Speed, Stability, Transparency, Cost Optimization, and Sustainability.',
      McPickupServers:'Our service includes pick-up in 185 cities, sortation, export declaration, international shipping, import customs clearance, last-mile delivery, and shipment tracking. Multi-Channel is aimed to redefine our users’ cross border logistics experiences through Speed, Stability, Transparency, Cost Optimization, and Sustainability.',
      PickupCoverag:'Pick-Up Coverage',
      PickupCoverags:'Yinchuan, Jinan, Qingdao, Yantai, Weihai, Weifang, Xi’an, Xianyang, Lanzhou, Nanchang, Shijiazhuang, Baigou, Langfang, Nanjing, Wuxi, Suzhou, Nantong, Zhenjiang, Changzhou, Lianyungang, Zhengzhou, Nanyang, Hangzhou, Jinhua, Yiwu, Lishui, Ningbo, Wenzhou, Yueqing, Taizhou, Cixi, Pingyang, Ruian, Yuyao, Jiaxing, hefei, Wuhan, Fuzhou, Xiamen, Quanzhou, Jinjiang, Chengdu, Tianjin, Huludao, Chongqing, Beijing, Changsha, Shanghai, Guangzhou, Shantou, Dongguan, Foshan, Shenzhen, Zhongshan, Zhuhai.',
      items: {
        '01': '<b>Shipment Coverage：52 countries and regions around the world</b><br/>USA, United Kingdom, Germany, Australia, Canada, Italy, France, Spain, Israel, New Zealand and 41 other European countries',
        '02': '<b>Delivery Time</b><br/>Standard service：8-12 business days<br/>Economy service：10-15 business days',
        '03': '<b>Visualized Shipment Tracking</b><br/>Synchronized to eBay and eDIS platform in real time Tracking service is also provided on the official website of Orange Connex: www.orangeconnex.com/tracking',
        '04': '<b>Chargeable Units</b><br/>Shipment parcels are charged by weights (g). Chargeable thresholds for USA, Australia, and Canada starting at 50g/parcel',
        '05': '<b>Pick-up Coverage</b><br/>26 provinces, 185 cities in China (Starting with 1 package, no service fee)<br/>14 drop off stations in Hong Kong',
        '06': '<b>A-Scan</b><br/>24 hours A-Scan upload guaranteed<br/>A-Scan time recorded at pick-up',
        '07': '<br/>Standard API for 3<sup>rd</sup> party ERP integration '
      },
      pickup: '<h5><b>Pick-Up Coverage</b></h5><br/>Ready for pick up and drop off service provinces <br/>27 provinces (including Hong Kong), 185 cities, 788 districts <br/><br/>Prepare to open drop off service provinces <br/>(1 province "Taiwan", 21 cities and districts)<br/><br/>Service method: pick up and drop off<br/>Drop off window time: Monday to Saturday, 10:00 – 18:00',
      warehouse:{
        warehouseIntr:'Speed Freight',
        warehouseIntr1: 'Consol Freight Product',
        warehouseIntr2: 'Owning excellent system construction and strong supplier management, Orange Connex launched Speed Freight service to help the sellers to set up overseas warehouses and sell the goods to the world easily.',
        itemsCf: {
          '01': '<b>Ocean freight – LCL (less than container load) + truck delivery</b><br/>Fix sailing date per week, leaving Shanghai/Shenzhen (Yantian) port to Los Angeles & New York',
          '02': '<br><b>Covering oversea warehouses in West & East coast of US, and service area is expanding</b>',
          '03': '<br><b>Service lead time from goods depart from origin port to goods receipt in oversea warehouse: 22-50 calendar days</b>',
          '04': '<br><b>Origin warehouse open for cargo 7 x 24 (except holidays)</b>',
          '05': '<b>Easy to order</b><br/>Online inquiry service by operations center is Mon-Sat, to ensure quick response to customers’ needs',
          '06': '<b>End-to-end track & trace</b><br/>From goods arrived origin warehouse to goods receipt in oversea warehouse, real time tracking to be updated for customers check',
          '07': '<b>Pick up service is available for mainland CN</b><br/>Currently pick up coverage includes Shanghai, Guangzhou & Shenzhen, keeps expanding',
          '08': '<b>Transparent and clear service bill</b><br/>Rate card is all-in service fee. Easy-checked bill make customers’ logistics cost always under control',
          '09': '<b>Good cargo security</b><br/>End-to-end professional monitoring, providing insurance service. For loss and/or damage, claims can be done within agreed amount',
        },
      },
      finance:{
        '01': '<b>Features</b><br/>Credit loan with amount up to <b>RMB 300,000</b>, interest rate as low as <b>0.03%</b> per </br>day, credit term as long as <b>3 months</b>\n',
        '02': '<b>Advantages</b><br/>No collateral requirement, loan ready in 3 business days after applying, apply </br>online only, no strict limits on loan usage, flexible borrowing and repaying </br>options\n',
        '03': '<b>Application Requirements</b><br/>Company legal person or individual business owner, 20 to 55 </br>years old, eBay store registered over 1 year, OCL account </br>registered over 6 months, average monthly eBay store GMV over </br>RMB 30,000\n',
        '04': '<b>Process</b><br/>Click “applying” on SpeedPAK recharge page, read and accept user </br>terms and conditions, submit application on partnering financial </br>institution\'s online platform\n',
        '05': '<b>Apply Now</b><br/>Please contact us or check financial product entrance on SpeedPAK </br>recharge page for more information (financial product customer service </br>hotline 400 165 0008)\n',

        intr1:'OCL Referral Financial Product\n',
        intr2:'Credit Loan for Cross-border e-Commerce Sellers\n'
      },
      multiChannel:{
        title:'Multi-Channel',
        intr:'The Multi-Channel solution is based on the SpeedPAK network jointly created by eBay and Orange Connex.  Provide customers with multi-channel direct logistics service products through market analysis, system development and resource integration. Provide globle E-commerce businesses with World-class service quality and full-circle supply chain solution. Support customers cross-border business growth and service quality. ',
        items:{
        '01': '<p style="line-height: 16px;">Shipment Coverage: 52 countries and regions around the world  <br/>USA,United Kingdom,Germany,Australia,Canada,France,Italy,Spain and other countries </p>',
        '02': '<p style="line-height: 16px;"><b>Delivery Time</b><br/>Standard service: 8-12 business days<br/>Economy service:10-15 business days</p>',
        '03': '<p style="line-height: 16px;"><b>Pick-up Coverage</b><br/>185 cities in China ( Starting with 1 package, no service fee)</p>',
        '04': '<p style="line-height: 16px;"><b>Visualized Shipment Tracking</b><br/>Tracking event can be checked via ERP, 17 Track,Multi-Channel platform and Orange Connex website</p>',
        '05': '<p style="line-height: 16px;margin-top:19px"><b>Chargeable Units</b><br/>Shipment parcels are charged by weights(g）. Chargesable thresholds for USA, Austrialia, and Canada starting at 50g/parcel, Singaport and Malaysia starting at 10g/parcel</p>',
        '06': '<p style="line-height: 16px;"><b>A-Scan</b><br/>24 hours A-Scan upload guaranteed<br/>A-Scan time recorded at pick-up</p>',
        '07': '<p style="line-height: 16px;">Standard API for 3rd party ERP integration </p>',
        '08': '<p style="line-height: 16px;"><b>Who has Joined us</b><br/>Dian Xiao Mi ERP<br/>MABANG ERP<br/>Pu Yuan ERP<br/>Tong Tu ERP</p>',
        }
      },
      tab2:'Speed Freight',
      spkInfo:'SpeedPAK service is jointly built by eBay and Orange Connex (China) Limited. Developed on the foundation of eBay’s platform policy, then customized to provide direct mail service to e-commerce businesses in the great China region.',
      mcInfo:'The Multi-Channel solution is based on the SpeedPAK network jointly created by eBay and Orange Connex. Provide globle E-commerce businesses with World-class service quality and full-circle supply chain solution.',
      shipmentCoverage1:'Shipment Coverage',
      shipmentCoverage2:'50 countries and regions around the world',
      shipmentCoverage3:'USA, United Kingdom, Germany, Australia, Canada, France, Italy, Spain, Israel, New Zealand and 41 other European countries',
      deliveryTime1:'Delivery Time',
      deliveryTime2:'Standard service：',
      deliveryTime3:'8-12 business days',
      deliveryTime4:'Economy service：',
      deliveryTime5:'10-15 business days',
      chargeableUnits1:'Chargeable Units',
      chargeableUnits2:'Shipment parcels are charged by weights (g). Chargeable thresholds for USA, Australia, and Canada starting at 50g/parcel',
      tracking1:'Visualized Shipment Tracking',
      tracking2:'Track on Orange Connex',
      tracking3:'Synchronized to eBay and eDIS platform in real time Tracking service is also provided on the official website of Orange Connex',
      tracking4:'Tracking event can be checked via ERP, 17 Track, Multi-Channel platform and Orange Connex website',
      pickupCoverage1:'Pick-up Coverage',
      pickupCoverage2:'26 provinces, 185 cities in China (Starting with 1 package, no service fee)',
      pickupCoverage3:'14 drop off stations in Hong Kong',
      aScan1:'A-Scan',
      aScan2:'24 hours A-Scan upload guaranteed',
      aScan3:'A-Scan time recorded at pick-up',
      mc1:'Who has Joined us:',
      spk1:'Standard API for 3rd party ERP integration'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/Product_local.js